import {
  hasEventPaymentIssue,
  hasEventLocationIssue,
  isExpiredEvent,
  allInviteesDeclined,
  eventHasInternalConflict,
  hasEventPassed,
} from 'shared/utils/get_badge_key'

export type WarningKey =
  | 'PAYMENT_ERROR'
  | 'ACTION_NEEDED'
  | 'EXPIRED'
  | 'INVITEES_DECLINED'
  | 'CONFLICT'

type CheckFn = (event: any, options: { otherEventsOnDay: any[] }, scopeType: string) => boolean

const warningChecks: Array<{ check: CheckFn; key: WarningKey }> = [
  { check: (event) => hasEventPaymentIssue(event), key: 'PAYMENT_ERROR' },
  { check: (event) => hasEventLocationIssue(event) && !hasEventPassed(event), key: 'ACTION_NEEDED' },
  { check: (event) => isExpiredEvent(event), key: 'EXPIRED' },
  { check: (event) => allInviteesDeclined(event), key: 'INVITEES_DECLINED' },
  { check: (event, options, scopeType) => eventHasInternalConflict(event, options, scopeType), key: 'CONFLICT' },
]

/**
 * Returns the highest-priority warning key for a meeting, or null if none apply.
 * Warning statuses are informational/action-required badges independent of
 * time-based statuses. Priority order matches the legacy getBadgeKey ordering.
 */
export const getWarningKey = (
  event: any,
  scopeType: string,
  { otherEventsOnDay }: { otherEventsOnDay: any[] },
): WarningKey | null => {
  const match = warningChecks.find(
    ({ check }) => check(event, { otherEventsOnDay }, scopeType),
  )
  return match?.key ?? null
}
